import React from "react";
import { JAPAN_STEPS } from "../../data/courseDataJapan";

const JapanSteps = () => {
  return (
    <section id="jl-how-it-works" className="jl-section jl-steps">
      <div className="container">
        <header className="section-header wow fadeInUp">
          <span className="jl-section-label jl-section-label--light">ご利用の流れ</span>
          <h2 className="about_head jl-steps__title">
            かんたん3ステップで
            <span className="highlighted-text">学習をスタート</span>
          </h2>
          <p className="jl-section-subtitle jl-section-subtitle--light">
            無料体験レッスンから資格取得まで、安心のサポート体制です。
          </p>
        </header>

        <div className="jl-steps-grid">
          {JAPAN_STEPS.map((step, index) => (
            <div
              key={step.number}
              className="jl-step-card wow fadeInUp"
              data-wow-delay={`${index * 0.15}s`}
            >
              <div className="jl-step-card__number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JapanSteps;
